module.exports = "img/flags/MS.700755b.png";